export default __webpack_public_path__ + "static/media/paypal.f4fa3f0a.svg";